if (!customElements.get('comparison-table')) {
  customElements.define('comparison-table', class ComparisonTable extends HTMLElement {
    constructor() {
      super();
      this.viewMoreButton = this.querySelector('.js-view-more');
      this.viewLessButton = this.querySelector('.js-view-less');
      this.hiddenRows = this.querySelectorAll('.product-comparison__key.hidden, .product-comparison__data.hidden');
      this.addEventListeners();
    }

    addEventListeners() {
      if (this.viewMoreButton) {
        this.viewMoreButton.addEventListener('click', () => this.showMore());
      }

      if (this.viewLessButton) {
        this.viewLessButton.addEventListener('click', () => this.showLess());
      }
    }

    showMore() {
      this.hiddenRows.forEach((row) => row.classList.remove('hidden'));
      this.viewMoreButton.classList.add('hidden');
      this.viewLessButton.classList.remove('hidden');
    }

    showLess() {
      this.hiddenRows.forEach((row) => row.classList.add('hidden'));
      this.viewMoreButton.classList.remove('hidden');
      this.viewLessButton.classList.add('hidden');
    }
  });
}